interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: React.ReactNode;
  light?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, action, light }: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <p className={`mb-2 flex items-center gap-2 text-xs font-semibold tracking-wider uppercase ${light ? "text-accent-300" : "text-primary-600"}`}>
            <span className={`inline-block h-1.5 w-6 rounded-full ${light ? "bg-accent-400" : "bg-primary-500"}`} />
            {eyebrow}
          </p>
        )}
        <h2 className={`font-heading text-2xl font-extrabold tracking-tight md:text-3xl ${light ? "text-background-50" : "text-foreground-950"}`}>
          {title}
        </h2>
        {desc && (
          <p className={`mt-2 max-w-xl text-sm leading-relaxed ${light ? "text-background-100/80" : "text-foreground-500"}`}>
            {desc}
          </p>
        )}
      </div>
      {action}
    </div>
  );
}